import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getPricingType = async () => {
  return await get<ApiResponse<any[]>>("/pricingtype").then((res) => res);
};

